import { createPortal } from "react-dom"

export function GlobalStyle({ children }: { children: string }) {
	if (typeof document === "undefined") return null
	return createPortal(<style>{children}</style>, document.head)
}